import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { submit, isSubmitting } from 'redux-form';

import capitalize from 'capitalize';
import FlatButton from 'material-ui/FlatButton';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import PaymentPreferenceForm from './options_popover/PaymentPreferenceForm';
import LeaseNotesForm from './options_popover/LeaseNotesForm';
import PrePaymentForm from './options_popover/PrePaymentsForm';
import PaymentsLedger from './options_popover/PaymentsLedger';
import Documents from './options_popover/Documents';
import DocumentUploader from 'components/shared/DocumentUploader';

import * as landlordTenantsActions from 'actions/landlordTenantsActions';
import { openEditLease, clearLeaseDetails } from 'actions/LeaseDetailsActions';

import { AccentColor } from 'helpers/AccentColorHelper';
import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';

let rentRollNonGrid = connect(
  store => {
    return {
      tenants: store.landlordTenants.tenants,
      reportPaymentTenants: store.landlordPayments.tenants,
      showPreviousLeads: store.landlordTenants.showPreviousLeads,
      leaseId: store.landlordTenants.leaseId,
      showOptionsMenu: store.landlordTenants.showOptionsMenu,
      anchorEl: store.landlordTenants.anchorEl,
      showPaymentPreference: store.landlordTenants.showPaymentPreference,
      showPrePayment: store.landlordTenants.showPrePayment,
      prePayments: store.landlordTenants.prePayments,
      showLeaseNotesDialog: store.landlordTenants.showLeaseNotesDialog,
      lease_note: store.landlordTenants.lease_note,
      showManualRenewalDialog: store.landlordTenants.showManualRenewalDialog,
      documentUploaderDialogOpen: store.landlordTenants.documentUploaderDialogOpen,
      leaseDetails: store.leaseDetails.leaseDetails,
      shouldFreeze: store.landlordTenants.shouldFreeze,
      unitId: store.landlordTenants.unitId,
      showUnitOptions: store.landlordTenants.showUnitOptions,
      showPaymentsLedgerDialog: store.landlordTenants.showPaymentsLedgerDialog,
      leadId: store.landlordTenants.leadId,
      showLeadOptions: store.landlordTenants.showLeadOptions,
      leadNotInvited: store.landlordTenants.leadNotInvited,
      leadDetails: store.landlordTenants.leadDetails,
      cotenantDetails: store.landlordLeads.leadDetails,
      showDocuments: store.landlordTenants.showDocuments,
      displayMode: store.landlordTenants.displayMode,
      isSubmittingPrepayment: isSubmitting('pre_payments_form')(store),
    };
  },
  {
    ...landlordTenantsActions,
    openEditLease,
    submit,
    clearLeaseDetails,
  }
)(
  class RentRollNonGrid extends Component {
    constructor(props) {
      super(props);
      this.state = {
        documentUploaderDialogOpen: false,
      };
    }

    toggleDocumentUploaderDialog = () => {
      this.props.toggleDocumentUploaderDialogOpen(!this.props.documentUploaderDialogOpen);
    };

    handleClose = () => {
      this.props.closePaymentPreference();
      this.props.closeOptionsMenu(this.props.leaseDetails.id);
    };

    handlePrePayClose = () => {
      this.props.closePrePayments();
      this.props.closeOptionsMenu(this.props.leaseDetails.id);
    };

    closeManualRenewalCreator = () => {
      this.props.closeManualRenewalCreator();
      this.props.closeOptionsMenu(this.props.leaseDetails.id);
    };

    closeDocuments = () => {
      this.props.closeDocuments();
    };

    render() {
      const titleContentStyle = { textAlign: 'center', margin: 0 };

      const documentTypes = {
        'Frequently Used': [
          'Certificate of Service',
          'Inspection Report',
          'Lease',
          'Notice',
          'Renters Insurance',
          'Termination Agreement',
        ],
        Other: ['Other'],
      };

      return (
        <Fragment>
          <Dialog
            disableBackdropClick
            fullScreen={this.props.fullScreen}
            open={this.props.showPrePayment}
            onClose={this.handlePrePayClose}
            aria-labelledby="report-payment"
            classes={{
              paper: 'form-dialog',
            }}
          >
            <DialogTitle id="report-payment">
              <h3 style={titleContentStyle}>
                {getTranslatedString('landlordPortal.rentRollNonGrid.prePaymentsDialogTitle')}
              </h3>
            </DialogTitle>
            <DialogContent>
              <PrePaymentForm />
            </DialogContent>
            <DialogActions style={{ display: 'block' }}>
              <FlatButton
                onClick={this.handlePrePayClose}
                id="close-button"
                style={{ color: AccentColor() }}
              >
                {getTranslatedString('landlordPortal.rentRollNonGrid.close')}
              </FlatButton>
              <FlatButton
                variant="raised"
                onClick={() => this.props.submit('pre_payments_form')}
                id="submit-button"
                disabled={this.props.isSubmittingPrepayment}
                style={{
                  color: 'white',
                  backgroundColor: this.props.isSubmittingPrepayment
                    ? colors.LIGHT_GRAY
                    : AccentColor(),
                  padding: '-1px',
                }}
              >
                {getTranslatedString('landlordPortal.rentRollNonGrid.save')}
              </FlatButton>
            </DialogActions>
          </Dialog>
          <Dialog
            disableBackdropClick
            fullScreen={this.props.fullScreen}
            open={this.props.showPaymentPreference}
            onClose={this.handleClose}
            aria-labelledby="payment-preference"
            classes={{
              paper: 'form-dialog',
            }}
          >
            <DialogTitle id="payment-preference">
              <h3 style={titleContentStyle}>Payment Preference</h3>
            </DialogTitle>
            <DialogContent>
              <PaymentPreferenceForm
                onSubmit={this.submitForm}
                properties={this.props.properties}
              />
            </DialogContent>
            <DialogActions style={{ display: 'block' }}>
              <FlatButton
                onClick={this.handleClose}
                id="close-button"
                style={{ color: AccentColor() }}
              >
                {getTranslatedString('landlordPortal.rentRollNonGrid.close')}
              </FlatButton>
              <FlatButton
                variant="raised"
                onClick={() => this.props.submit('payment_preference_form')}
                id="submit-button"
                style={{
                  color: 'white',
                  backgroundColor: AccentColor(),
                }}
              >
                {getTranslatedString('landlordPortal.rentRollNonGrid.save')}
              </FlatButton>
            </DialogActions>
          </Dialog>
          <Dialog
            disableBackdropClick
            fullScreen={this.props.fullScreen}
            open={this.props.showLeaseNotesDialog}
            onClose={this.closeLeaseNotes}
            aria-labelledby="lease-notes"
            classes={{
              paper: 'form-dialog',
            }}
          >
            <DialogTitle id="lease-notes">
              <h3 style={titleContentStyle}>Lease Notes</h3>
            </DialogTitle>
            <DialogContent>
              <LeaseNotesForm
                onSubmit={this.submitLeaseNotesForm}
                handleClose={this.closeLeaseNotes}
              />
            </DialogContent>
            <DialogActions style={{ display: 'block' }}>
              <FlatButton
                onClick={this.closeLeaseNotes}
                id="close-button"
                style={{ color: AccentColor() }}
              >
                {getTranslatedString('landlordPortal.rentRollNonGrid.close')}
              </FlatButton>
              <FlatButton
                variant="raised"
                onClick={() => this.props.submit('lease_note_form')}
                id="submit-button"
                style={{
                  color: 'white',
                  backgroundColor: AccentColor(),
                }}
              >
                {getTranslatedString('landlordPortal.rentRollNonGrid.save')}
              </FlatButton>
            </DialogActions>
          </Dialog>
          <Dialog
            disableBackdropClick
            fullScreen={this.props.fullScreen}
            open={this.props.showPaymentsLedgerDialog}
            onClose={() => {
              this.props.openPaymentsLedgerDialog(false);
            }}
            aria-labelledby="unit-payment-ledger"
            classes={{
              paper: 'form-dialog',
            }}
          >
            <DialogTitle id="unit-payment-ledger">
              <h3 style={titleContentStyle}>Unit Payment Ledger</h3>
            </DialogTitle>
            <DialogContent>
              <PaymentsLedger />
            </DialogContent>
            <DialogActions style={{ display: 'block' }}>
              <FlatButton
                onClick={this.closePaymentsLedger}
                id="close-button"
                style={{ color: AccentColor() }}
              >
                {getTranslatedString('landlordPortal.rentRollNonGrid.close')}
              </FlatButton>
            </DialogActions>
          </Dialog>
          <Dialog
            fullScreen={this.props.fullScreen}
            open={this.props.showDocuments}
            onClose={() => {
              this.props.closeDocuments();
            }}
            aria-labelledby="documents"
            classes={{
              paper: 'form-dialog',
            }}
          >
            <DialogTitle id="documents">
              <h3 style={titleContentStyle}>
                {capitalize(this.props.displayMode || '')} Documents
              </h3>
            </DialogTitle>
            <DialogContent>
              <Documents handleClose={this.closeDocuments} />
            </DialogContent>

            <DialogActions style={{ display: 'block' }}>
              <FlatButton
                onClick={this.closeDocuments}
                id="close-button"
                style={{ color: AccentColor() }}
              >
                {getTranslatedString('landlordPortal.rentRollNonGrid.close')}
              </FlatButton>
            </DialogActions>
          </Dialog>

          <DocumentUploader
            documentTypes={documentTypes}
            dialogOpen={this.props.documentUploaderDialogOpen}
            toggleDialog={this.toggleDocumentUploaderDialog}
            handleSubmit={data => this.props.createDocument(data, this.props.leaseDetails.id)}
          />
        </Fragment>
      );
    }
  }
);

export default withMobileDialog()(rentRollNonGrid);
